module.exports = __webpack_public_path__ + "static/img/govcard_white_06.89d60367.svg";